import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { FORM, TYPOGRAPHY } from "@store/theme/design";
import { transitionHoverStyles } from "@store/theme/mixins";
import { polyfillCss } from "@store/theme/polyfills";
import updateCssValue, { Operators } from "@store/utilities/updateCssValue";

const baseOptionStyles = () => polyfillCss`
    padding: 0.75em 1em;
    background-color: ${getColor("common.background")};
    font-size: ${TYPOGRAPHY.size.smaller};
    ${transitionHoverStyles("color", "background-color")}
`;

export default {
    defaultProps: {
        cssOverrides: {
            list: polyfillCss`
                width: 100%;
                top: 100%;
                border: none;
                box-shadow: ${getProp("theme.shadows.main")};
            `,
            option: polyfillCss`
                ${baseOptionStyles()}
                color: ${getColor("text.main")};

                &:hover {
                    background-color: ${getColor("primary")};
                    color: ${getColor("primary.contrast")};
                }
            `,
            noOptions: polyfillCss`
                ${baseOptionStyles()}
                color: ${getColor("text.disabled")};
                font-style: italic;
                cursor: default;
            `,
            selectedText: polyfillCss`
                text-overflow: ellipsis;
                top: 50%;
                transform: translateY(-50%);
                padding: 0;
                margin: 0 ${FORM.field.padding};
                width: calc(100% - ${updateCssValue(FORM.field.padding, Operators.Multiply, 2)} - 2em);
            `,
        },
    },
};
